const storageKey = 'themeViewer'
const themeMarker = 'dx.material.'
export { storageKey, themeMarker }
